import React, { useEffect, useState } from 'react';
import { Save, Search, ExternalLink, Image as ImageIcon, Globe, Eye } from 'lucide-react';
import { api } from '../../lib/api';
import { toast } from 'sonner';
import UploadButton from './UploadButton';

// Editable public pages
const PAGES = [
  { key: 'home', label: 'Anasayfa', path: '/', defaultTitle: 'YEKÜV — Bir Çocuk Daha Okusun Diye', defaultDesc: '1992\'den bu yana 12.500+ bursiyere ulaşan vakıf. Bağışlarınızla yarına dokunun.', kicker: 'Genel' },
  { key: 'about', label: 'Hakkımızda / Kurumsal', path: '/kurumsal', defaultTitle: 'Kurumsal — Hakkımızda', defaultDesc: '21. Yüzyıl Eğitim ve Kültür Vakfı\'nın tarihçesi, vizyonu, misyonu ve yönetim kurulu.', kicker: 'Kurumsal' },
  { key: 'presidents', label: 'Başkanlarımız', path: '/kurumsal/baskanlar', defaultTitle: 'Başkanlarımız', defaultDesc: 'Vakfımızın kuruluşundan bugüne hizmet eden değerli başkanlarımız.', kicker: 'Kurumsal' },
  { key: 'boards', label: 'Kurullarımız', path: '/kurumsal/kurullar', defaultTitle: 'Kurullarımız', defaultDesc: 'Yönetim, denetim ve danışma kurullarımız.', kicker: 'Kurumsal' },
  { key: 'media', label: 'Medyada YEKÜV', path: '/kurumsal/medya', defaultTitle: 'Medyada YEKÜV', defaultDesc: 'Vakfımızın basında, televizyonda ve dijital medyada yer alan haberleri.', kicker: 'Kurumsal' },
  { key: 'units', label: 'Eğitim Destek Birimleri', path: '/kurumsal/birimler', defaultTitle: 'Eğitim Destek Birimlerimiz', defaultDesc: 'İstanbul\'un farklı ilçelerinde hizmet veren eğitim merkezlerimiz.', kicker: 'Kurumsal' },
  { key: 'sponsors', label: 'Destekçilerimiz', path: '/kurumsal/destekciler', defaultTitle: 'Destekçilerimiz', defaultDesc: 'YEKÜV\'ü destekleyen kurumlar, vakıflar ve gönüllüler.', kicker: 'Kurumsal' },
  { key: 'school', label: 'Nilüfer Gökay Okulu', path: '/kurumsal/okul', defaultTitle: 'YEKÜV Nilüfer Gökay Ortaokulu', defaultDesc: 'Vakfımızın eğitim mirasını taşıyan ortaokulumuz.', kicker: 'Kurumsal' },
  { key: 'tax', label: 'Vergi Muafiyeti', path: '/kurumsal/vergi', defaultTitle: 'Kamu Yararına Vergi Muafiyeti', defaultDesc: 'YEKÜV bağışlarınız için vergi avantajı sağlar.', kicker: 'Kurumsal' },
  { key: 'kvkk', label: 'KVKK', path: '/kurumsal/kvkk', defaultTitle: 'KVKK Aydınlatma Metni', defaultDesc: '6698 sayılı kanun kapsamında kişisel verilerin korunması politikamız.', kicker: 'Kurumsal' },
  { key: 'donate', label: 'Bağış (Online)', path: '/bagis', defaultTitle: 'Online Bağış', defaultDesc: 'Güvenli ödeme altyapısıyla anında bağış yapın. Hayata dokunmaya başlayın.', kicker: 'Bağış' },
  { key: 'donation_types', label: 'Bağış Türleri', path: '/bagis/turler', defaultTitle: 'Bağış Türlerimiz', defaultDesc: 'Genel bağış, özel gün, proje bağışı, devre bursu ve aylık eğitim bursu.', kicker: 'Bağış' },
  { key: 'special_day', label: 'Özel Gün Bağışı', path: '/bagis/ozel-gun', defaultTitle: 'Özel Gün Bağışı', defaultDesc: 'Doğum günü, yıl dönümü, anma için sevdiklerinize anlamlı bir hediye.', kicker: 'Bağış' },
  { key: 'donation_channels', label: 'Bağış Kanalları', path: '/bagis/kanallar', defaultTitle: 'Bağış Kanallarımız', defaultDesc: 'Banka hesapları, IBAN bilgileri ve diğer bağış yolları.', kicker: 'Bağış' },
  { key: 'scholarships', label: 'Burslar', path: '/burslar', defaultTitle: 'Burslarımız', defaultDesc: 'Üniversite, lise ve ortaokul öğrencileri için karşılıksız eğitim bursu başvurusu.', kicker: 'Burs' },
  { key: 'projects', label: 'Projeler & Etkinlikler', path: '/projeler', defaultTitle: 'Projeler & Etkinliklerimiz', defaultDesc: 'Devam eden ve tamamlanan projelerimiz, sosyal & kültürel etkinliklerimiz.', kicker: 'Projeler' },
  { key: 'news', label: 'Duyurular', path: '/duyurular', defaultTitle: 'Duyurular & Haberler', defaultDesc: 'Vakfımızdan en güncel haberler, etkinlikler ve duyurular.', kicker: 'İletişim' },
  { key: 'contact', label: 'İletişim', path: '/iletisim', defaultTitle: 'İletişim', defaultDesc: 'YEKÜV\'e ulaşmanın yolları: telefon, e-posta, adres ve sosyal medya.', kicker: 'İletişim' },
  { key: 'volunteer', label: 'Gönüllülük', path: '/gonullu', defaultTitle: 'Gönüllü Olun', defaultDesc: 'Bireysel veya kurumsal olarak vakfımızın gönüllüsü olun, fark yaratın.', kicker: 'İletişim' },
];

export default function AdminSEO() {
  const [active, setActive] = useState('home');
  const [values, setValues] = useState({});
  const [filter, setFilter] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.adminListSettings().then(list => {
      const m = {};
      list.forEach(s => { m[s.key] = s.value; });
      setValues(m);
    }).catch(() => {});
  }, []);

  const cur = PAGES.find(p => p.key === active);
  const v = (suffix) => values[`seo_${active}_${suffix}`] || '';
  const setV = (suffix, val) => setValues(s => ({ ...s, [`seo_${active}_${suffix}`]: val }));

  const save = async () => {
    setSaving(true);
    try {
      await Promise.all(
        ['title', 'description', 'og_image', 'keywords'].map(suffix => {
          const key = `seo_${active}_${suffix}`;
          return api.adminUpsertSetting(key, values[key] || '');
        })
      );
      toast.success(`${cur.label} SEO kaydedildi`);
    } catch {
      toast.error('Kaydedilemedi');
    } finally { setSaving(false); }
  };

  const pageGroups = PAGES.reduce((acc, p) => {
    if (!filter || p.label.toLowerCase().includes(filter.toLowerCase()) || p.path.includes(filter.toLowerCase())) {
      (acc[p.kicker] = acc[p.kicker] || []).push(p);
    }
    return acc;
  }, {});

  // Live preview values
  const titleP = v('title') || cur.defaultTitle;
  const descP = v('description') || cur.defaultDesc;
  const ogP = v('og_image');
  const fullTitleP = `${titleP} · YEKÜV`;
  const urlP = `demo.yekuvakademi.org${cur.path}`;
  const titleLen = (v('title') || cur.defaultTitle).length;
  const descLen = (v('description') || cur.defaultDesc).length;

  return (
    <div data-testid="admin-seo">
      <div className="mb-6">
        <div className="text-[11px] tracking-[0.3em] uppercase text-coral-300 font-bold">Pazarlama</div>
        <h1 className="font-display text-4xl mt-2 leading-none">SEO & Meta Yöneticisi</h1>
        <p className="mt-2 text-ink-400 text-sm max-w-3xl">
          Her public sayfa için <strong>Sayfa Başlığı</strong>, <strong>Açıklama</strong>, <strong>Anahtar Kelimeler</strong> ve <strong>OG (paylaşım) görseli</strong>ni buradan yönetin.
          Bu bilgiler Google arama sonuçlarında ve WhatsApp/Twitter/LinkedIn paylaşım önizlemelerinde kullanılır.
        </p>
      </div>

      <div className="grid lg:grid-cols-[300px_1fr] gap-6">
        {/* Page list */}
        <div className="bg-white rounded-2xl border border-ink-100 p-3 self-start lg:sticky lg:top-20">
          <div className="px-2 py-2">
            <div className="relative">
              <Search className="w-3.5 h-3.5 absolute left-3 top-1/2 -translate-y-1/2 text-ink-400" />
              <input
                value={filter}
                onChange={e => setFilter(e.target.value)}
                placeholder="Sayfa ara..."
                className="w-full h-9 pl-8 pr-3 rounded-lg bg-cream-200 border border-ink-100 focus:border-ink-500 outline-none text-xs"
              />
            </div>
          </div>
          <div className="space-y-2">
            {Object.entries(pageGroups).map(([group, pages]) => (
              <div key={group}>
                <div className="px-2 pt-3 pb-1 text-[9px] uppercase tracking-[0.3em] text-ink-400 font-bold">{group}</div>
                {pages.map(p => {
                  const has = !!values[`seo_${p.key}_title`];
                  return (
                    <button key={p.key} onClick={() => setActive(p.key)} data-testid={`seo-page-${p.key}`}
                      className={`w-full text-left px-2.5 py-2 rounded-lg text-xs transition-colors flex items-start gap-2 ${active === p.key ? 'bg-ink-600 text-cream' : 'text-ink-500 hover:bg-cream-200'}`}>
                      <div className={`w-1.5 h-1.5 rounded-full mt-1.5 shrink-0 ${has ? 'bg-emerald-400' : 'bg-ink-300'}`} title={has ? 'Düzenlendi' : 'Varsayılan'} />
                      <div className="flex-1 min-w-0">
                        <div className="font-semibold truncate">{p.label}</div>
                        <div className={`text-[10px] mt-0.5 font-mono truncate ${active === p.key ? 'text-cream/60' : 'text-ink-400'}`}>{p.path}</div>
                      </div>
                    </button>
                  );
                })}
              </div>
            ))}
          </div>
        </div>

        {/* Editor + preview */}
        <div className="space-y-5">
          <div className="bg-white rounded-2xl border border-ink-100 p-6 lg:p-7">
            <div className="flex flex-wrap items-center justify-between gap-3 mb-5">
              <div>
                <div className="text-[10px] tracking-[0.25em] uppercase text-coral-300 font-bold">{cur.kicker}</div>
                <h2 className="font-display text-2xl mt-1">{cur.label}</h2>
                <a href={cur.path} target="_blank" rel="noopener noreferrer" className="text-xs text-ink-400 hover:text-ink-600 mt-1 inline-flex items-center gap-1">
                  <ExternalLink className="w-3 h-3" /> Sayfayı görüntüle
                </a>
              </div>
              <button onClick={save} disabled={saving} data-testid="save-seo" className="bg-ink-600 text-cream rounded-full px-6 h-11 text-sm font-semibold hover:bg-ink-500 inline-flex items-center gap-2 disabled:opacity-60">
                <Save className="w-4 h-4" /> {saving ? 'Kaydediliyor...' : 'Kaydet'}
              </button>
            </div>

            <div className="space-y-4">
              <Field
                label="Sayfa Başlığı"
                hint={`Tarayıcı sekmesinde ve Google'da görünür. ${titleLen}/60 karakter ${titleLen > 60 ? '(çok uzun)' : titleLen > 0 ? '✓' : ''}`}
                tone={titleLen > 60 ? 'warn' : titleLen > 0 ? 'good' : 'idle'}
                value={v('title')}
                onChange={x => setV('title', x)}
                placeholder={cur.defaultTitle}
                testid="field-seo-title"
              />
              <Field
                label="Meta Açıklama"
                hint={`Google arama sonuçlarında 1-2 satır olarak görünür. ${descLen}/160 karakter ${descLen > 160 ? '(çok uzun)' : descLen > 0 ? '✓' : ''}`}
                tone={descLen > 160 ? 'warn' : descLen > 0 ? 'good' : 'idle'}
                value={v('description')}
                onChange={x => setV('description', x)}
                placeholder={cur.defaultDesc}
                long
                testid="field-seo-description"
              />
              <Field
                label="Anahtar Kelimeler"
                hint="Virgülle ayırın. Örn: vakıf, eğitim bursu, bağış, gönüllülük"
                value={v('keywords')}
                onChange={x => setV('keywords', x)}
                placeholder="vakıf, bağış, eğitim bursu, gönüllülük"
                testid="field-seo-keywords"
              />

              <div>
                <label className="text-[10px] tracking-[0.25em] uppercase text-ink-400 font-bold">Paylaşım Görseli (OG / Open Graph)</label>
                <div className="text-xs text-ink-400 mt-0.5">WhatsApp, Twitter, LinkedIn gibi platformlarda link paylaşıldığında görünen görsel. Önerilen: 1200x630 px JPG/PNG.</div>
                <div className="mt-2 flex gap-2">
                  <input value={v('og_image')} onChange={e => setV('og_image', e.target.value)} placeholder="/uploads/seo-home.jpg veya tam URL" className="flex-1 bg-cream-200 border border-ink-100 focus:border-ink-500 rounded-xl px-3 h-10 text-sm outline-none font-mono" />
                  <UploadButton onUploaded={url => setV('og_image', url)} label="Yükle" />
                </div>
                {ogP && <img src={ogP} alt="OG preview" className="mt-3 rounded-lg border border-ink-100 max-h-44" />}
              </div>
            </div>
          </div>

          {/* Live previews */}
          <div className="grid md:grid-cols-2 gap-4">
            <div className="bg-white rounded-2xl border border-ink-100 p-5">
              <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.25em] text-coral-300 font-bold"><Globe className="w-3.5 h-3.5" /> Google Önizleme</div>
              <div className="mt-3">
                <div className="text-[#202124] text-base">{urlP}</div>
                <div className="text-[#1a0dab] text-lg leading-snug mt-1 hover:underline cursor-pointer">{fullTitleP}</div>
                <div className="text-[#4d5156] text-sm leading-snug mt-1 line-clamp-2">{descP}</div>
              </div>
            </div>

            <div className="bg-white rounded-2xl border border-ink-100 p-5">
              <div className="flex items-center gap-2 text-[10px] uppercase tracking-[0.25em] text-coral-300 font-bold"><Eye className="w-3.5 h-3.5" /> Sosyal Medya Önizleme</div>
              <div className="mt-3 rounded-lg overflow-hidden border border-ink-100">
                {ogP ? (
                  <div className="aspect-[1200/630] bg-ink-50">
                    <img src={ogP} alt="" className="w-full h-full object-cover" />
                  </div>
                ) : (
                  <div className="aspect-[1200/630] bg-cream-200 grid place-items-center text-ink-400">
                    <div className="text-center">
                      <ImageIcon className="w-8 h-8 mx-auto opacity-40" />
                      <div className="text-xs mt-2">OG görseli yüklenmedi</div>
                    </div>
                  </div>
                )}
                <div className="p-3 bg-cream-200">
                  <div className="text-[10px] uppercase text-ink-400 truncate">demo.yekuvakademi.org</div>
                  <div className="text-sm font-semibold text-ink-700 mt-0.5 line-clamp-2">{fullTitleP}</div>
                  <div className="text-xs text-ink-400 mt-0.5 line-clamp-2">{descP}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Field({ label, hint, value, onChange, placeholder, long, testid, tone }) {
  const toneCls = tone === 'warn' ? 'text-coral-300' : tone === 'good' ? 'text-emerald-600' : 'text-ink-400';
  return (
    <div>
      <label className="text-[10px] tracking-[0.25em] uppercase text-ink-400 font-bold">{label}</label>
      {hint && <div className={`text-[11px] mt-0.5 ${toneCls}`}>{hint}</div>}
      {long ? (
        <textarea
          value={value || ''}
          onChange={e => onChange(e.target.value)}
          placeholder={placeholder}
          rows={3}
          data-testid={testid}
          className="mt-2 w-full bg-cream-200 border border-ink-100 focus:border-ink-500 rounded-xl px-3 py-2.5 text-sm outline-none resize-none"
        />
      ) : (
        <input
          value={value || ''}
          onChange={e => onChange(e.target.value)}
          placeholder={placeholder}
          data-testid={testid}
          className="mt-2 w-full bg-cream-200 border border-ink-100 focus:border-ink-500 rounded-xl px-3 h-10 text-sm outline-none"
        />
      )}
    </div>
  );
}
